
const GEMINI_KEY = 'AIzaSyAdWICPoW2BEjuEph8B_Jn_5LuHBk-2Pts';

export const askAI = async (question, resumeText) => {

  try {
    const response = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=' + GEMINI_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        contents: [
          {
            role: 'user', parts: [
              {
                text: `
                  You are an AI assistant for my personal portfolio. 
                  
                  STRICT RULES:
                  - Answer ONLY using the resume provided below.
                  - Be concise and professional.
                  - Do NOT add any information that is not present in the resume.
                  - If the answer is not present, reply exactly:
                    "I don't have that information about Puneet."
  
                  FORMATTING RULES (IMPORTANT):
                  - If an answer contains multiple items (skills, tools, projects, contact details, links), 
                    ALWAYS put EACH item on a NEW LINE.
                  - Add 
                  - Do NOT combine multiple items in a single line.
                  - Do NOT use commas to separate items.
                  - Use plain text only (no markdown, no emojis).
  
                  QUESTION-SPECIFIC RULES:
                  1) IF the user specifically asks "What skills does Puneet have?" then ONLY list skills in below format:
                    - Group skills into exactly TWO sections:
                      Technical Skills
                      Tools
                    - Use this exact format:
                      Technical Skills :- item1, item2, item3
                      Tools :- item1, item2, item3
                    - Use commas to separate items.
                    - Do NOT put each skill on a new line.
                    - Do NOT merge Technical Skills and Tools.
                  OTHERWISE, IF the user asks any particular skills like "Does puneet know react or ant design?" then answer like a real conversation without any lists.

                  2) IF the user specifically asks "How can I contact Puneet?" then ONLY list contact details in below format:
                    - Use exactly THREE lines in this exact order:
                      Email :- <email>
                      Linkedin :- <linkedin url with username>
                      Phone :- <phone number>
                    - Each field must be on its own line.
                    - Do NOT remove labels.
                    - Do NOT merge fields into one line.
                  OTHERWISE, IF the user asks any particular contact details like "Is this puneet's number 9460694015 or similar kind of question?" then answer like a real conversation without any lists.

                  3) IF the user asks "Who is Puneet?" or similar:
                    - Write a short introduction (2–4 lines).
                    - Include location and years of experience if present.
                    - Do NOT list skills here.

                  4) IF the user specifically asks "What projects has Puneet worked on?" then ONLY list projects in below format:
                    - Use exactly this line with comma separated projects:
                      "Current projects that Puneet has worked on are :- <project 1>, <project 2> and <project 3>".
                  OTHERWISE, IF the user asks any particular project details like "Does puneet worked on quick note application or similar kind of question?" then answer like a real conversation without any lists.
                  IMPORTANT :- THESE ARE OTHER PROJECTS WHICH PUNEET HAS WORKED ON, AND THESE ARE NOT IN THE RESUME. SO IF USER SPECIFICALLY ASKS ABOUT ANY PROJECT THEN TELL THEM, YES, PUNEET HAS WORKED ON THESE PROJECTS. 
                  AND THE PROJECTS ARE - 
                  1. Google Docs, 2. Quick Note, 3. Lumen Translate, 4. Dictionary App, 5. Realtime Chat Application, 6. Weather Application, 7. Music Player

                  5) FOR ALL THE OTHER TYPE OF QUESTIONS:
                    - Use complete sentences with comma if needed.
  
                  Resume:
                  ${resumeText}
  
                  Question:
                  ${question}
                `
              }
            ]
          }
        ]
      }),
    });

    if (!response.ok) {
      // Handle rate limit explicitly
      if (response.status === 429) {
        return "I’m experiencing high traffic right now. Please try again in a few seconds.";
      }

      // Generic API error
      return "I’m unable to respond right now. Please try again later.";
    }

    const data = await response.json();

    return data.candidates?.[0]?.content?.parts?.[0]?.text;
  }
  catch (error) {
    return "I’m unable to respond right now. Please try again later."
  }
}